<template>
  <div class="approval">
    <div class="treeList">
      <div class="treeItem">分类1</div>
      <div class="treeItem">分类2</div>
      <div class="treeItem">分类3</div>
    </div>
    <div class="content">
      <el-container>
        <el-header>
          <el-form :inline="true" :model="dataForm" label-width="100px">
            <el-row>
              <el-col :span="8">
                <el-form-item label="标题：">
                  <el-input v-model="dataForm.billHead" placeholder="请输入标题" clearable></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="发文字号：">
                  <el-input v-model="dataForm.billHead" placeholder="请输入发文字号" clearable></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="16">
                <el-form-item label="发布日期：">
                  <el-date-picker
                      v-model="dataForm.approveTime"
                      @change="approveTimeChange"
                      type="daterange"
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      :default-time="['00:00:00', '23:59:59']">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="8" class="btnRight">
                <el-form-item class="btnList">
                  <el-button type="primary" @click="query()">查 询</el-button>
                  <el-button type="info" @click="reset()">重 置</el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-header>
        <el-main ref="main">
          <el-table
              ref="dataTable"
              :data="documentList"
              highlight-current-row
              @current-change="handleSelectionChange"
              @row-click="rowClicked"
              @cell-dblclick="dblclickDetail"
              size="mini"
              height="100%"
              border
          >
            <el-table-column type="index" width="50"></el-table-column>
            <el-table-column
                prop="approveCode"
                label="标题"
                :show-overflow-tooltip="true"
            ></el-table-column>
            <el-table-column
                prop="approveCode"
                label="公文分类"
                :show-overflow-tooltip="true"
            ></el-table-column>
            <el-table-column
                prop="approveCode"
                label="发文字号"
                :show-overflow-tooltip="true"
            ></el-table-column>
            <el-table-column
                prop="approveCode"
                label="发文日期"
                :show-overflow-tooltip="true"
            ></el-table-column>
            <el-table-column
                prop="approveCode"
                label="发布日期"
                :show-overflow-tooltip="true"
            ></el-table-column>
            <el-table-column
                prop="approveCode"
                label="审批状态"
                :show-overflow-tooltip="true"
            ></el-table-column>
            <el-table-column label="操作" header-align="center" align="center" width="100">
              <template slot-scope="scope">
                <el-button type="text" size="small" @click="goToDetails(scope.row)">详情</el-button>
                <el-button type="text" size="small" @click="goToDetails(scope.row)">审批</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-main>
      </el-container>
    </div>
  </div>
</template>

<script>
export default {
  name: "index",
  data(){
    return {
      dataForm: {
        billHead: '',
        approveTime: [],
        approveStartTime:'',
        approveEndTime:'',
      },
      documentList: [{}],
    }
  },
  methods:{
    approveTimeChange(val){
      if(val){
        this.dataForm.approveStartTime = this.dataForm.approveTime[0];
        this.dataForm.approveEndTime = this.dataForm.approveTime[1];
      }else{
        this.dataForm.approveStartTime = '';
        this.dataForm.approveEndTime = '';
      }
    },
    // 列代表多选回调
    handleSelectionChange(val) {
      this.selectItems = val;
    },
    // 点击选中行
    rowClicked(row, event, column) {
      this.$refs.dataTable.toggleRowSelection(row);
    },
    // 双击
    dblclickDetail(row, column, cell, event) {
      this.bus.$emit("navMenuChange", {
        routeId: "salesInvoiceDetail",
        routeParam: {
          approveId: row.id
        }
      });
    },
    // 去详情页
    goToDetails(item){
      this.bus.$emit("navMenuChange", {
        routeId: "documentApprovalDetails",
        routeParam: {
          // id: item.id
        }
      });
    },
    // 去打印页面
    goToPrint(item = null){
      this.bus.$emit("navMenuChange", {
        routeId: "documentManagePrint",
        routeParam: {
          id: item!= null? item.id: ''
        }
      });
    },
  }
}
</script>

<style scoped lang="scss">
  @import "@/assets/css/commonLayout.scss";
  .approval{
    height: 100%;
    display: flex;
    justify-content: space-between;
    .treeList{
      width: 15%;
      background-color: white;
      .treeItem{
        width: 100%;
        height: 50px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
    .content{
      width: 83%;
      background-color: white;
    }
  }
  .btnRight {
    display: flex;
    justify-content: flex-end;
    .btnList{
      text-align: right;
    }
    /deep/.el-form-item__content{
      height: auto;
    }
  }
</style>